import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from "rxjs";
import { Table } from "primeng/table";
// Model
import { BroadcastService, ModalService, ModalSize } from "@cv-invision/core";
// Service
import { ClientIdentifierListService } from "./service/client-identifier-list.service";
// Component

import { Router } from "@angular/router";
import { ProductIdentifierList } from "./components/product-identifier/product-identifier-list.component";
import { ClientIdentifierList } from "./components/client-identifier/client-identifier-list.component";

@Component({
	selector: 'cv-integrations-list',
	styleUrls: ['./integrations-list.component.scss'],
	templateUrl: './integrations-list.component.html',
	providers: [ConfirmationService, MessageService]
})
export class IntegrationListComponent implements OnInit, OnDestroy {
	public integrations: any = [];
	public searchField: string = '';
	public currentSection: string = '';

	@Input() formBuilderConfig: any;
	@Input() model: any;

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		public confirmationService: ConfirmationService,
		protected service: ClientIdentifierListService,
		public messageService: MessageService,
		protected modalService: ModalService,
		protected componentFactoryResolver: ComponentFactoryResolver,
		protected broadcast: BroadcastService,
		private router: Router
	) { }

	async ngOnInit(): Promise<void> {
		const currentUrl = this.router.url;

		switch(true) {
			case currentUrl.includes('product-identifier'):
				this.currentSection = 'product-identifier';
				break;
			default:
				this.currentSection = 'client-identifier';
				break;
		}
		this.loadData();
	}

	/**
	 * Get the data from the service
	 */
	private loadData() {
		this.service
			.getAllIntegrations()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.integrations = result.map((row: any, index: any) => (
					{
						...{ id: index },
						name: row
					}
				));
			});
	}

	/**
	 * Edit the integration
	 * @param integrationName string
	 */
	public editIntegration(integrationName: string): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: ClientIdentifierList,
				data: {
					integrationName
				},
				modalConfiguration: {
					title: 'Client Identifier List',
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe();
	}

	/**
	 * Edit the Product indentifier
	 * @param integrationName string
	 */
	public editProductIdentifier(integrationName: string): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: ProductIdentifierList,
				data: {
					integrationName
				},
				modalConfiguration: {
					title: 'Product Identifier List',
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe();
	}

	/**
	 * Apply Global Filter
	 * @param $event
	 * @param table
	 */
	applyGlobalFilter($event: any, table: Table): void {
		table.filterGlobal($event.target.value, 'contains');
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}